import { render, staticRenderFns } from "./MaterialSubgroup.vue?vue&type=template&id=c154c178&scoped=true"
import script from "./MaterialSubgroup.vue?vue&type=script&lang=js"
export * from "./MaterialSubgroup.vue?vue&type=script&lang=js"
import style0 from "./MaterialSubgroup.vue?vue&type=style&index=0&id=c154c178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c154c178",
  null
  
)

export default component.exports